// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1TZXI","description":"PatientConsentPreview_description__4EYwH"};